export enum GameDetailsTabsOptions {
  HighWin = 'high-win',
  LuckyWin = 'lucky-win',
  Description = 'description',
  Review = 'review',
}

export interface GameDetailsTabsProps {
  onTabChange: (tab: GameDetailsTabsOptions) => void;
  current: GameDetailsTabsOptions;
  isLoading?: boolean;
}
